import { STORAGE_KEY } from '@/config';
import type { AppState } from './state';

export function loadRaw(): AppState | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const s = JSON.parse(raw) as AppState;
    return s && s.cameras ? s : null;
  } catch {
    return null;
  }
}

export function saveRaw(s: AppState): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(s));
  } catch {
    /* quota / private mode — ignore */
  }
}
